<template>
    <el-row
        class="territorio-argentina-inserir"
        :gutter="20"
        style="padding-top: 15px"
    >
        <el-col :span="8">
            <h4 style="font-weight: 800; padding-bottom: 6px">
                {{ $t('mensagens.territorio.territorioAr.upload.title') }}
            </h4>
            <el-card class="w-full">
                <div v-if="layers.length == 0">
                    <p>
                        {{
                            $t('mensagens.territorio.territorioAr.upload.info')
                        }}
                    </p>
                    <div>
                        <p>
                            {{
                                $t(
                                    'mensagens.territorio.territorioAr.upload.enviar'
                                )
                            }}
                        </p>
                        <el-upload
                            class="upload-demo"
                            drag
                            action="alert"
                            :auto-upload="false"
                            :on-change="onLoadFile"
                            :on-remove="onRemoveFile"
                            :file-list="arquivosUploads"
                            multiple
                            ref="upload"
                        >
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">
                                {{
                                    $t(
                                        'mensagens.territorio.territorioAr.upload.card'
                                    )
                                }}
                            </div>
                        </el-upload>
                    </div>

                    <el-divider>
                        {{
                            $t('mensagens.territorio.territorioAr.upload.ou')
                        }}</el-divider
                    >
                    <div>
                        <p>
                            {{
                                $t(
                                    'mensagens.territorio.territorioAr.upload.manual'
                                )
                            }}
                        </p>
                        <el-button
                            type="primary"
                            icon="el-icon-edit"
                            style="width: 100%"
                            @click="onActiveMap"
                            >{{
                                $t(
                                    'mensagens.territorio.territorioAr.upload.botao'
                                )
                            }}</el-button
                        >
                    </div>
                    <!-- <el-divider>
                        {{
                            $t('mensagens.territorio.territorioAr.upload.ou')
                        }}</el-divider
                    >
                    <p>
                        {{
                            $t('mensagens.territorio.territorioAr.upload.cuit')
                        }}
                    </p> -->
                    <!-- <div>
                        <span>CUIT</span>
                        <el-input
                            placeholder="Ex 093182948"
                            prefix-icon="el-icon-search"
                            v-model="input2"
                        >
                        </el-input>
                    </div> -->
                </div>
                <div v-else style="background: #f5f5f5; border-radius: 4px">
                    <div v-for="(item, index) in layers" :key="index">
                        <div style="padding: 15px">
                            <div>
                                <p>
                                    {{
                                        $t(
                                            'mensagens.territorio.labels.departamento'
                                        )
                                    }}:
                                    <span>{{ item.departamento }}</span>
                                </p>
                                <p>
                                    {{
                                        $t(
                                            'mensagens.territorio.labels.distrito'
                                        )
                                    }}:
                                    <span>{{ item.distrito }}</span>
                                </p>
                                <div class="flex">
                                    <dl
                                        style="
                                            width: 18px;
                                            height: 18px;
                                            border-radius: 4px;
                                            background-color: #ddac44;
                                        "
                                    ></dl>
                                    <p>
                                        {{
                                            $t(
                                                'mensagens.territorio.territorioAr.upload.total'
                                            )
                                        }}:
                                    </p>
                                    <span>{{
                                        parseFloat(item.area_ha).toFixed(4)
                                    }}</span>
                                </div>
                                <div class="flex">
                                    <dl
                                        style="
                                            width: 18px;
                                            height: 18px;
                                            border-radius: 4px;
                                            background-color: #346995;
                                        "
                                    ></dl>
                                    <p>
                                        {{
                                            $t(
                                                'mensagens.territorio.territorioAr.upload.plantio'
                                            )
                                        }}:
                                    </p>
                                </div>
                                <span>{{ item.totalPlantio }}</span>
                            </div>
                        </div>
                        <el-button
                            style="
                                margin: 16px;
                                color: #dc362e;
                                border-color: #dc362e;
                            "
                            @click="onRemoveFile(item)"
                        >
                            {{
                                $t(
                                    'mensagens.territorio.territorioAr.upload.eliminar'
                                )
                            }}
                        </el-button>
                    </div>
                </div>
            </el-card>
        </el-col>
        <el-col :span="16">
            <mapa
                class="map-content"
                :mapLayersConfigs="layers"
                :mapConfig="mapConfig"
                :idMapa="'mapaAddTerritorio'"
                :height="'598px'"
                @draw-created="adicionarDesenho"
                @draw-edited="desenhosAlterados"
                @removerTerritorio="removerTerritorio"
                :deslocarPopup="true"
                :menuMaior="true"
                :cadastroTerritorio="true"
                ref="mapa"
            ></mapa>
        </el-col>
    </el-row>
</template>
<script>
import L from 'leaflet';
import Mapa from '@/components/MapaLeaflet';
import geometryUtils from '@/utils/mapa/geometry.js';
import geometryConverter from '@/utils/conversorGeometrias';
// import territorioService from '@/services/TerritorioService';
import { mapActions } from 'vuex';
export default {
    name: 'informacaoEspecial',
    data() {
        return {
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    popupControl: true,
                    drawControl: true
                },
                dontZoomIn: true,
                fitBounds: true,
                addLimitesEstado: false,
                inspecionar: true
            },
            mapa: '',
            layersMaps: [],
            arquivosUploads: [],
            geometryDesenho: null
        };
    },
    props: {
        isEdit: {
            type: Boolean,
            default: true
        },
        layers: {
            type: Array,
            default: () => []
        },
        geometria: {
            type: Object,
            default: () => {}
        },
        informacoes: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        Mapa
    },
    computed: {},
    methods: {
        ...mapActions(['replaceTerritoryTableData']),

        onActiveMap() {
            this.$refs.mapa.draw();
        },

        onDelete() {
            this.arquivosUploads = [];
        },

        onLoadFile(file) {
            const reader = new FileReader();
            const extension = file.name.split('.').pop().toLowerCase();

            reader.onload = async e => {
                await geometryConverter
                    .read(extension, e.target.result, file.raw)
                    .then(geometria => {
                        this.processarGeometria(geometria, file.name);

                        this.arquivosUploads.push({
                            id: file.uid,
                            layer: geometria,
                            name: file.name
                        });
                    })
                    .catch(rejectReason => {
                        this.$refs.upload.clearFiles();
                        this.$notify.error({ message: rejectReason });
                    });
            };

            reader.readAsText(file.raw);
        },
        onRemoveFile(file) {
            const indexRemover = this.arquivosUploads.findIndex(
                o => o.uid === file.id
            );

            if (indexRemover !== -1) {
                this.$refs.mapa.mapa.removeLayer(
                    this.arquivosUploads[indexRemover].layer
                );
                this.arquivosUploads.splice(indexRemover, 1);
            }

            const index = this.layers.findIndex(
                d => d.identificadorGeometria === file.identificadorGeometria
            );

            if (index !== -1) {
                const layer = this.layers[index];

                this.$emit('remover', index);
                this.$refs.mapa.mapa.removeLayer(layer);
            }
        },

        removerTerritorio(identificadorGeometria) {
            this.layers.forEach((item, index) => {
                if (identificadorGeometria === item.identificadorGeometria) {
                    this.$emit('remover', index);
                }
            });
        },

        adicionarDesenho(desenho) {
            desenho.identificadorGeometria = desenho._leaflet_id;
            const territorio = {
                identificadorGeometria: desenho._leaflet_id,
                type: 'Desenho de geometria',
                codigo: 'DESENHO',
                area_ha: geometryUtils.calcularAreaHaFromLayer(desenho),
                geometry: desenho.toGeoJSON().geometry,
                geoJson: desenho.toGeoJSON().geometry,
                departamento: '',
                distrito: ''
            };

            this.$emit('add', territorio);
        },

        desenhosAlterados(desenhosAlterados) {
            desenhosAlterados.eachLayer(layer => {
                const areaHa = geometryUtils.calcularAreaHaFromLayer(layer);
                const geometry = layer.toGeoJSON().geometry;

                this.layers.findIndex(
                    t => t.identificadorGeometria === layer._leaflet_id
                );

                this.replaceTerritoryTableData({
                    identificadorGeometria: layer._leaflet_id,
                    geometry,
                    areaHa
                });
            });
        },

        processarGeometria(geometria, fileName) {
            this.filtrarGeometrias(geometria);
            if (geometria !== null && geometria.getLayers().length > 0) {
                if (
                    geometria.getLayers()[0].feature.geometry.type ===
                    'GeometryCollection'
                ) {
                    geometria
                        .getLayers()[0]
                        .getLayers.forEach(layer =>
                            this.processarLayer(geometria, layer, fileName)
                        );
                } else {
                    geometria
                        .getLayers()
                        .forEach(layer =>
                            this.processarLayer(geometria, layer, fileName)
                        );
                }
            } else {
                this.$refs.upload.clearFiles();

                this.$notify.error({
                    message: this.$t(
                        'mensagens.territorio.arquivoNaoPossuiGeometriaValida'
                    )
                });
            }
        },

        filtrarGeometrias(layerGeometrias) {
            if (!layerGeometrias) return;
            if (layerGeometrias.getLayers) {
                layerGeometrias.getLayers().forEach(layer => {
                    if (!(layer instanceof L.Polygon)) {
                        if (layer instanceof L.LayerGroup) {
                            return this.filtrarGeometrias(layer);
                        }

                        if (layer instanceof L.Polyline) {
                            const coordinates = layer.getLatLngs();
                            if (!this.isValidLatLngArray(coordinates)) {
                                console.warn(
                                    'Coordenadas inválidas para Polyline:',
                                    coordinates
                                );
                                return;
                            }

                            return this.filtrarGeometrias(layer);
                        }

                        layerGeometrias.removeLayer(layer);
                    }
                });
            } else {
                if (!(layerGeometrias instanceof L.Polygon)) {
                    return L.featureGroup();
                }
            }
        },

        processarLayer(geometria, layer, fileName) {
            let geometriaPolygon = this.verificaTipoCorretoGeometria(
                layer.feature.geometry
            );

            const territorio = {
                identificadorGeometria: geometria._leaflet_id,
                type: 'UPLOAD',
                codigo: 'UPLOAD',
                area_ha: geometryUtils.calcularAreaHaFromLayer(layer),
                geometry: geometriaPolygon,
                fileName,
                departamento: '',
                distrito: ''
            };

            this.$emit('add', territorio);

            geometria.setStyle({ color: 'red' });

            this.$refs.mapa.mapa.addLayer(geometria);
            this.$refs.mapa.mapa.fitBounds(geometria.getBounds());
        },

        isValidLatLngArray(latlngArray) {
            if (!Array.isArray(latlngArray) || latlngArray.length === 0) {
                return false;
            }

            return latlngArray.every(coord => {
                if (Array.isArray(coord)) {
                    return this.isValidLatLngArray(coord);
                }
                return (
                    coord &&
                    coord.lat !== undefined &&
                    coord.lng !== undefined &&
                    coord.lat >= -90 &&
                    coord.lat <= 90 &&
                    coord.lng >= -180 &&
                    coord.lng <= 180
                );
            });
        },

        verificaTipoCorretoGeometria(geometria) {
            if (geometria.type === 'LineString') {
                const coordinates = [...geometria.coordinates];
                if (coordinates.length === 0) return null;

                coordinates.push(coordinates[0]);

                return {
                    type: 'Polygon',
                    coordinates: [coordinates]
                };
            }

            return geometria;
        }
    }
};
</script>
<style lang="scss">
.territorio-argentina-inserir {
    .el-card {
        height: calc(598px - 25.6px);
        .el-card__body {
            height: calc(598px - 25.6px);
            overflow-y: scroll;
        }
    }
}
.map-content-infor-especial {
    padding-top: 23px;
    width: 100%;
    height: 598px;
}
</style>
